import { EmployeeCountIO,AddressIO, UrlIO } from "../company-io";
import fetchApi from "../fetch-api";
import * as t from "io-ts";
type Props = {
	companyID: string;
	body: FilterT;
}
type FilterT = t.TypeOf<
	typeof filterCodec
>;
const filterCodec = t.partial({
	description: t.string,
	emp_count: t.array(EmployeeCountIO),
	industry: t.type({
			sic_code: t.string,
			lsic_code: t.string,
			industry: t.string,
			sub_industry: t.string,
			category: t.array(t.string),
	}),
	url: UrlIO,
	tags: t.array(t.string),
	address:t.array(AddressIO),
	badges: t.array(t.union([t.null, t.string])),
	company_type: t.string,
});
const UpdateCompanyCodec = t.type({
	acknowledged: t.boolean,
	modifiedCount: t.number,
	upsertedId: t.union([t.null, t.string]),
	upsertedCount: t.number,
	matchedCount: t.number
})
export const updateCompany = (props: Props) => {
	const { companyID, body } = props

	return fetchApi({
		service: "admin-service",
		method: "POST",
		headers: { "Content-Type": "application/json" },
		pathname: `/update-company?companyID=${companyID}`,
		codec: UpdateCompanyCodec,
		body: body,
	});
};